var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 18.9584C5.05829 18.9584 1.04163 14.9417 1.04163 10.0001C1.04163 5.05841 5.05829 1.04175 9.99996 1.04175C14.9416 1.04175 18.9583 5.05841 18.9583 10.0001C18.9583 14.9417 14.9416 18.9584 9.99996 18.9584ZM9.99996 2.29175C5.74996 2.29175 2.29163 5.75008 2.29163 10.0001C2.29163 14.2501 5.74996 17.7084 9.99996 17.7084C14.25 17.7084 17.7083 14.2501 17.7083 10.0001C17.7083 5.75008 14.25 2.29175 9.99996 2.29175Z",
    fill: "#6D6F73"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.64172 12.9834C7.48338 12.9834 7.32505 12.925 7.20005 12.8C6.95838 12.5584 6.95838 12.1584 7.20005 11.9167L11.9167 7.20005C12.1584 6.95838 12.5584 6.95838 12.8 7.20005C13.0417 7.44172 13.0417 7.84172 12.8 8.08338L8.08338 12.8C7.96671 12.925 7.80005 12.9834 7.64172 12.9834Z",
    fill: "#6D6F73"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3584 12.9834C12.2 12.9834 12.0417 12.925 11.9167 12.8L7.20005 8.08338C6.95838 7.84172 6.95838 7.44172 7.20005 7.20005C7.44172 6.95838 7.84172 6.95838 8.08338 7.20005L12.8 11.9167C13.0417 12.1584 13.0417 12.5584 12.8 12.8C12.675 12.925 12.5167 12.9834 12.3584 12.9834Z",
    fill: "#6D6F73"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.815d02e16257666292bb970e0ad99da2.svg";
export { ForwardRef as ReactComponent };